import OutboundLoadsRequests from '../../server/outboundLoads';
import { addLoading, removeLoading } from './loading';

export const getOutboundLoads = (
  startDate,
  endDate,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.getOutboundLoads(
      startDate,
      endDate,
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const getOutboundLoad = (outboundLoadId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.getOutboundLoad(outboundLoadId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getLoadOrders = (
  outboundLoadId,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.getLoadOrders(
      outboundLoadId,
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const toggleLoadPriority = (outboundLoadId, isUrgent) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.toggleLoadPriority(outboundLoadId, isUrgent);
  } finally {
    dispatch(removeLoading());
  }
};

export const linkDock = (outboundLoadId, dockCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.linkDock(outboundLoadId, dockCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const unlinkDock = (outboundLoadId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.unlinkDock(outboundLoadId);
  } finally {
    dispatch(removeLoading());
  }
};

export const changeDock = (outboundLoadId, dockCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.changeDock(outboundLoadId, dockCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const verifyDockControl = (outboundLoadId, dockCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.verifyDockControl(outboundLoadId, dockCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelOutboundLoad = (outboundLoadId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundLoadsRequests.cancelOutboundLoad(outboundLoadId);
  } finally {
    dispatch(removeLoading());
  }
};
